// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__4blwT","inner":"Banner_inner__uxu4M","header":"Banner_header__gV7HK","hgroup":"Banner_hgroup__JQWxy","text":"Banner_text__Yh0HV"};